import React from 'react';
import {
  Shield, FileText, RefreshCw, Truck, CreditCard, Cookie, CheckSquare, AlertTriangle, FileKey, Lock, Ban, Undo, Eye, MessageSquare, Award, Megaphone, Mail, Users, Send, AlertCircle, Check, Loader2, File, Copy, Menu, X, Trash2, ChevronDown, Sun, Moon, Save, Pencil, Clock, CheckCircle2, Share2, Search, Link, Instagram, Youtube, Facebook, Info, Sparkles
} from 'lucide-react';
import type { IconProps, IconName } from '../types';

// Fix: Consolidate all icons into a single map to satisfy the IconName type and fix the TypeScript error.
const iconComponents: { [key in IconName]: React.ElementType } = {
  Shield,
  FileText,
  RefreshCw,
  Truck,
  CreditCard,
  Cookie,
  CheckSquare,
  AlertTriangle,
  FileKey,
  Lock,
  Ban,
  Undo,
  Eye,
  MessageSquare,
  Award,
  Megaphone,
  Mail,
  Users,
  Paperclip: FileText, // Alias as Paperclip isn't a standard lucide icon, using FileText
  Moon,
  Sun,
  X,
  Menu,
  AlertCircle,
  Loader2,
  File,
  Copy,
  Check,
  Send,
  ChevronDown,
  Trash2,
  Save,
  Pencil,
  Clock,
  CheckCircle2,
  Share2,
  Search,
  Link,
  Instagram,
  Youtube,
  Facebook,
  Info,
  Sparkles,
};


const Icon: React.FC<IconProps> = ({ name, ...props }) => {
  const LucideIcon = iconComponents[name];
  if (!LucideIcon) {
    console.warn(`Icon "${name}" not found, falling back to FileText`);
    const FallbackIcon = FileText;
    return <FallbackIcon {...props} />;
  }
  return <LucideIcon {...props} />;
};

export default Icon;